import React from 'react';

import {useTranslation} from 'react-i18next';

import {BackTo} from 'components/common/BackTo';
import {ContentContainer} from 'components/ui-kit/PageComponents';
import {ROUTE} from 'core/routes';
import {OrdersCreateGate} from 'models/orders/create';

import {OrderProducts} from './products';

export const CreateTransportOrder = () => {
    const {t} = useTranslation();
    return (
        <>
            <BackTo to={ROUTE.ORDERS_GRID}>{t('pages.orders.back')}</BackTo>
            <ContentContainer>
                <h1>{t('pages.orders.newTransportOrder')}</h1>
                <OrdersCreateGate />
                <OrderProducts />
                {/*<Stepper*/}
                {/*    steps={[*/}
                {/*        {*/}
                {/*            label: t('pages.orders.stepOne'),*/}
                {/*            component: <OrderForm />,*/}
                {/*        },*/}
                {/*        {*/}
                {/*            label: t('pages.orders.stepTwo'),*/}
                {/*            component: <OrderProducts />,*/}
                {/*        },*/}
                {/*        {*/}
                {/*            label: t('pages.orders.stepThree'),*/}
                {/*            component: <Preview />,*/}
                {/*        },*/}
                {/*    ]}*/}
                {/*    activeStep={step}*/}
                {/*/>*/}
            </ContentContainer>
        </>
    );
};
